import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { getter, Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import {
  getSelectedState,
  HeaderThElement,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { MdDelete, MdKeyboardBackspace } from "react-icons/md";
import AppDialog, {
  CustomAppDialog,
  CustomDialogCloseButton,
  DialogCloseButton,
} from "../../components/dialog/Dialog";
import {
  assignInquiryToUser,
  deleteInquiry,
  getAllInquiries,
  getFollowupsByInquiryID,
  getInquiryAssignUserHistory,
  insertFollowUp,
  updateFollowUpStatus,
  updateInquiryStageStatus,
  updateInquiryStatus,
} from "./services/inquiry.services";
import {
  clearInquiryFilterDetails,
  clearInquiryID,
  clearInquiryList,
  clearInquiryStageDetails,
  clearInquiryStatus,
  closeCompleteFollowupDialog,
  openCompleteFollowupDialog,
  setactiveTabIndex,
  setInquiryFilterDetails,
  setInquiryID,
  setInquiryStageDetails,
  setInquiryStatus,
  setTripID,
} from "./inquirySlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  FOLLOWUPSTATUS,
  // FOLLOWUPSTATUS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { getAllActiveUsers } from "../user/services/user.services";
import { IUser } from "../user/userModel";
import InquiryFilter from "./InquiryFilter";
import { ErrorToast } from "../../components/toast/Toasts";
import moment from "moment";
// import { setQuotationInformation } from "../quotation/quotationSlice";
import { TbReceiptRupee } from "react-icons/tb";
import IconComponent from "../../components/common/IconComponent";
import { RiEdit2Fill } from "react-icons/ri";
import ButtonForAll from "../../components/common/ButtonForAll";
import { ILeadStage } from "../leadstage/leadStageModel";
import { RxCross1 } from "react-icons/rx";
import { getAllActiveLeadStage } from "../leadstage/services/leadStage.services";
import FormDatePicker from "../../components/formFields/FormDateField";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import FormTimePicker from "../../components/formFields/FormTimeField";
import FormTextArea from "../../components/formFields/FormTextArea";
// import FormCheckbox from "../../components/formFields/FormCheckbox";
// import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import { BsBookmarkPlusFill } from "react-icons/bs";
import {
  clearCurrentPage,
  setCurrentPage,
  setPageLimit,
} from "../pagination/paginationSlice";
import { motion } from "framer-motion";
import { setFolloupID } from "../dashboard/dashboardSlice";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LuHistory } from "react-icons/lu";
import { getAllActiveLostReasons } from "../lostreason/services/lostReason.services";
import { ILostReason } from "../lostreason/lostReasonModel";
import { getAllAdNames } from "../lead/services/lead.services";

const Inquiry: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;

  const handleInquiryCreate = (ID: number, type: string) => {
    navigate("/inquiry/create", {
      state: {
        LeadID: type === "LeadID" ? ID : null,
        ContactID: type === "ContactID" ? ID : null,
      },
    });
  };

  return (
    <>
      <DeleteInquiryDialog />
      <InquiryFollowUpDialog />
      <InquiryStatusDialog />
      <InquiryFollowUpListDialog />
      <FollowupCompleteDialog />
      <InquiryHistoryDialog />
      <InquiryStageDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconButton
              fillMode="solid"
              title="Back"
              onClick={() => navigate(-1)}
              icon={MdKeyboardBackspace}
              iconClassName="absolute-position"
              style={{ height: 30 }}
              iconStyle={{ fontSize: "20px" }}
            />
            <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
              Inquiry List
            </Typography.h4>
          </div>
          {isAddAccess && (
            <Button
              onClick={() => {
                if (LeadID) {
                  handleInquiryCreate(LeadID, "LeadID");
                } else if (ContactID) {
                  handleInquiryCreate(ContactID, "ContactID");
                } else {
                  handleInquiryCreate(0, "Other");
                }
              }}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <InquiryGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const InquiryGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;
  const isEditBtnRef = useRef<any>(false);
  const isAddQuotationAccess = checkAcessRights("/quotation", INSERT_ACCESS);
  const isAddB2BQuotationAccess = checkAcessRights("/b2bquotation", INSERT_ACCESS);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const InquiryList = useAppSelector((state) => state.inquiry.InquiryList);
  const UserTypeIDString = useAppSelector(
    (state) => state.login.loginDetails.UserTypeID,
  );
  const UserTypeID = parseInt(UserTypeIDString);

  const activeTabIndex = useAppSelector(
    (state) => state.inquiry.activeTabIndex,
  );
  const loading = useAppSelector((state) => state.inquiry.loading);
  const formLoading = useAppSelector((state) => state.inquiry.formLoading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const InquiryFilterDetails = useAppSelector(
    (state) => state.inquiry.InquiryFilterDetails,
  );
  const InquiryStageCounts = useAppSelector(
    (state) => state.inquiry.InquiryStageCounts,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [rowSelectionModel, setRowSelectionModel] = React.useState<number[]>(
    [],
  );
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userRights: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userRights = JSON.parse(userResponseString);
  } catch (error) {
    userRights = [];
  }

  const isQuotationAccess =
    userRights?.some((e: any) => e.MenuKey === "quotation") ?? false;

  useEffect(() => {
    const matchFilter = (id: any, filterId: any) =>
      (!id && !filterId) || (id && filterId);

    const hasMatchingFilterID =
      matchFilter(ContactID, InquiryFilterDetails?.filterContactID) &&
      matchFilter(LeadID, InquiryFilterDetails?.filterLeadID);

    if (hasMatchingFilterID) {
      const payload = {
        ...InquiryFilterDetails,
        filterFromBudget: InquiryFilterDetails?.Budget?.start,
        filterToBudget: InquiryFilterDetails?.Budget?.end,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      dispatch(getAllInquiries(payload));
    }
  }, [InquiryFilterDetails, pageLimit, currentPage]);

  useEffect(() => {
    setSelectedState({});
    setRowSelectionModel([]);
  }, [InquiryList]);

  useEffect(() => {
    dispatch(getAllActiveUsers());
    dispatch(getAllAdNames());

    return () => {
      dispatch(closeDialog());
      dispatch(closeCompleteFollowupDialog());
      dispatch(clearInquiryList());
      if (!isEditBtnRef.current) {
        dispatch(setCurrentPage(0));
        dispatch(setPageLimit(50));
        dispatch(clearInquiryFilterDetails());
        dispatch(setactiveTabIndex(0));
      }
    };
  }, []);

  const dataState = InquiryList?.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem),
  );

  const DATA_ITEM_KEY: string = "ID";
  const SELECTED_FIELD: string = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    [selectedState],
  );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: { [key: string]: boolean } = {};

      event?.dataItems?.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key: string) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    [],
  );

  const MyEditCommandCell = (props: any) => {
    const handleEditInquiry = (data: any) => {
      navigate("/inquiry/edit", {
        state: { InquiryID: data?.ID, RequirementType: data?.RequirementType },
      });
    };
    const handleAddQuotation = (data: any) => {
      if (data?.RequirementType) {
        navigate(`/quotation/${data?.RequirementType?.toLowerCase()}/create`, {
          state: { InquiryID: data?.ID },
        });
      }
    };
    const handleCreateB2BQuotation = (InquiryID: number) => {
      navigate("/b2bquotation/create", {
        state: { InquiryID: InquiryID },
      });
    };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteInquiry"));
      dispatch(setInquiryID(ID));
    };

    const handleShowHistory = async (ID: number) => {
      const res = await dispatch(
        getInquiryAssignUserHistory({ InquiryID: `${ID}` }),
      );
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(openDialog("inquiryHistory"));
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              isEditBtnRef.current = true;
              handleEditInquiry(props.dataItem);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isAddQuotationAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Generate Quotation"
            onClick={() => handleAddQuotation(props.dataItem)}
            icon={TbReceiptRupee}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {isAddB2BQuotationAccess && props.dataItem?.RequirementType === "PACKAGE" && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Create B2B Quotation"
            onClick={() => handleCreateB2BQuotation(props.dataItem.ID)}
            icon={TbReceiptRupee}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {UserTypeID < 3 && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="User Assign History"
            themeColor="dark"
            onClick={() => handleShowHistory(props.dataItem.ID)}
            icon={LuHistory}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === (UserTypeID < 3 ? 16 : 15) ||
        props.index === (UserTypeID < 3 ? 15 : 14)
        ? "locked-header"
        : ""
        }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const CustomLeadStageCell = (props: any) => {
    const handleOpenFollowUpDialog = (ID: number) => {
      dispatch(openDialog("inquiryFollowUp"));
      dispatch(setInquiryID(ID));
    };

    const handleOpenFollowUpListDialog = (ID: number, TripID: string) => {
      dispatch(
        getFollowupsByInquiryID({
          ID: ID,
          FollowupType: "INQUIRY",
        }),
      );
      dispatch(openDialog("inquiryFollowUpList"));
      dispatch(setInquiryID(ID));
      dispatch(setTripID(TripID));
    };

    const handleOpenInquiryStageDialog = (data: any) => {
      dispatch(openDialog("inquiryStageChange"));
      dispatch(setInquiryID(data?.ID));
      // dispatch(setInquiryStageID(data?.InquiryStageID));
      dispatch(
        setInquiryStageDetails({
          LostReasonID: data?.LostReasonID,
          InquiryStageID: data?.InquiryStageID,
        }),
      );
    };

    return (
      <td
        {...props.tdProps}
        className={`${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <span
          className="mb-2 d-inline-block hoverable-leadstatus"
          style={{ cursor: "pointer" }}
          onClick={() => handleOpenInquiryStageDialog(props.dataItem)}
        >
          {props.dataItem?.InquiryStage} <IconComponent icon={RiEdit2Fill} />
        </span>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <Button
            themeColor={"primary"}
            type="button"
            fillMode="solid"
            size="small"
            className="d-block"
            onClick={() => handleOpenFollowUpDialog(props.dataItem.ID)}
          >
            Add Follow Up
          </Button>
          <Button
            themeColor={"primary"}
            type="button"
            fillMode="solid"
            size="small"
            className="d-block"
            onClick={() =>
              handleOpenFollowUpListDialog(
                props.dataItem.ID,
                props.dataItem.TripID,
              )
            }
          >
            Follow Up List {`(${props.dataItem.TotalNoofFollowup || 0})`}
          </Button>
        </div>
      </td>
    );
  };

  const CustomLeadStatusCell = (props: any) => {
    const handleOpenInquiryStageDialog = (data: any) => {
      dispatch(openDialog("inquiryStatusChange"));
      dispatch(setInquiryID(data?.ID));
      dispatch(setInquiryStatus(data?.InquiryType));
    };

    return (
      <td
        {...props.tdProps}
        className={`${props.className}`}
        style={{ ...props.tdProps.style, textAlign: "center" }}
      >
        <span
          className="mb-2 d-inline-block hoverable-leadstatus"
          style={{ cursor: "pointer" }}
          onClick={() => handleOpenInquiryStageDialog(props.dataItem)}
        >
          {props.dataItem?.InquiryType} <IconComponent icon={RiEdit2Fill} />
        </span>
      </td>
    );
  };

  const ListingButtonCell = (props: any) => {
    const handleQuotations = (ID: number) => {
      navigate("/quotation", { state: { InquiryID: ID } });
    };
    const handleBookings = (ID: number) => {
      navigate("/tourbooking", { state: { InquiryID: ID } });
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isQuotationAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Quotations"
            themeColor="success"
            style={{ marginRight: 5 }}
            onClick={() => handleQuotations(props.dataItem.ID)}
            icon={TbReceiptRupee}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {false && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Bookings"
            themeColor="tertiary"
            onClick={() => handleBookings(props.dataItem.ID)}
            icon={BsBookmarkPlusFill}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
      </td>
    );
  };

  const handleTabChange = (index: number) => {
    dispatch(clearCurrentPage());
    dispatch(setactiveTabIndex(index));
    dispatch(
      setInquiryFilterDetails({
        ...InquiryFilterDetails,
        filterInquiryStageID:
          index === 3
            ? 4
            : index === 5
              ? 5
              : index === 6
                ? 6
                : index === 4
                  ? 8
                  : null,
        filterUnassignedLeads: index === 2 ? true : false,
        filterIsNew: UserTypeID > 2 && index === 0 ? true : false,
        // filterFromDate: index === 1 ? "" : InquiryFilterDetails?.filterFromDate,
        // filterToDate: index === 1 ? "" : InquiryFilterDetails?.filterToDate,
        filterIsRecent: UserTypeID < 3 && index === 1 ? true : false,
      }),
    );
  };

  const handleSubmit = async (
    values: any,
    formRenderProps: FormRenderProps,
  ) => {
    if (rowSelectionModel?.length < 1) {
      ErrorToast("Please select atleast one!!!");
    } else {
      try {
        const payload = {
          InquiryID: rowSelectionModel ? rowSelectionModel?.join(", ") : "",
          UserID: values?.User ? +values?.User : null,
        };
        const response = await dispatch(assignInquiryToUser(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          formRenderProps.onChange("User", { value: null });
          const payload = {
            filterContactID: InquiryFilterDetails?.filterContactID,
            filterLeadID: InquiryFilterDetails?.filterLeadID,
            filterNoOfNights: InquiryFilterDetails?.filterNoOfNights,
            filterInquiryStageID: InquiryFilterDetails?.filterInquiryStageID,
            filterCity: InquiryFilterDetails?.filterCity,
            filterGoingfrom: InquiryFilterDetails?.filterGoingfrom,
            filterDestination: InquiryFilterDetails?.filterDestination,
            filterRequirementType: InquiryFilterDetails?.filterRequirementType,
            filterInquirySourceID: InquiryFilterDetails?.filterInquirySourceID,
            filterName: InquiryFilterDetails?.filterName,
            filterMobileNo: InquiryFilterDetails?.filterMobileNo,
            filterEmailID: InquiryFilterDetails?.filterEmailID,
            filterAssignedTo: InquiryFilterDetails?.filterAssignedTo,
            filterUnassignedLeads: InquiryFilterDetails?.filterUnassignedLeads,
            filterFromDate: InquiryFilterDetails?.filterFromDate,
            filterToDate: InquiryFilterDetails?.filterToDate,
            filterFromBudget: InquiryFilterDetails?.Budget?.start,
            filterToBudget: InquiryFilterDetails?.Budget?.end,
            filterIsRecent: InquiryFilterDetails?.filterIsRecent,
            filterAdName: InquiryFilterDetails?.filterAdName,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          };
          dispatch(getAllInquiries(payload));
          // dispatch(clearInquiryDetails());
          // navigate("/inquiry");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  const gridRef = useRef<any>(null);

  return (
    <>
      {(loading || formLoading) && <LoadingPanel gridRef={gridRef} />}
      <div
        style={{
          position: "relative",
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <InquiryFilter />
      </div>
      <Form
        // onSubmit={handleSubmit}
        // initialValues={InquiryPackageDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            {UserTypeID < 3 && (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "end",
                  padding: "10px",
                  border: "1px solid lightgray",
                  borderRadius: "5px",
                  boxShadow: "0 0 10px gainsboro",
                }}
              >
                <Field
                  wrapperClassName="m-0"
                  wrapperStyle={{ minWidth: 300 }}
                  name="User"
                  label="User"
                  placeholder="Select User"
                  component={FormSelectionField}
                  options={UserList?.map((user: IUser) => ({
                    value: user?.ID,
                    label: `${user?.FirstName} ${user?.LastName}`,
                  }))}
                />
                <Button
                  themeColor={"primary"}
                  fillMode={"solid"}
                  disabled={
                    !formRenderProps.valueGetter("User") ||
                    rowSelectionModel?.length < 1
                  }
                  onClick={() =>
                    handleSubmit(
                      { User: formRenderProps.valueGetter("User") },
                      formRenderProps,
                    )
                  }
                >
                  Assign
                </Button>
              </div>
            )}
          </FormElement>
        )}
      />
      <div
        style={{
          marginTop: 10,
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        {UserTypeID < 3 ? (
          <div style={{ display: "flex", gap: 10 }} className="mt-1 mb-3">
            <Button
              themeColor={"primary"}
              fillMode={activeTabIndex === 0 ? "solid" : "outline"}
              onClick={() => handleTabChange(0)}
            >
              Overall{" "}
              {InquiryStageCounts?.OverallLeads
                ? `(${InquiryStageCounts?.OverallLeads})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={activeTabIndex === 1 ? "solid" : "outline"}
              onClick={() => handleTabChange(1)}
            >
              Recent{" "}
              {InquiryStageCounts?.TotalRecentInquiries
                ? `(${InquiryStageCounts?.TotalRecentInquiries})`
                : ""}
            </Button>
            {UserTypeID < 3 && (
              <Button
                themeColor={"primary"}
                fillMode={activeTabIndex === 2 ? "solid" : "outline"}
                onClick={() => handleTabChange(2)}
              >
                Un-Assigned{" "}
                {InquiryStageCounts?.TotalUnassigned
                  ? `(${InquiryStageCounts?.TotalUnassigned})`
                  : ""}
              </Button>
            )}
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 4 ||
                  activeTabIndex === 3
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(3)}
            >
              In Progress{" "}
              {InquiryStageCounts?.TotalInProgress
                ? `(${InquiryStageCounts?.TotalInProgress})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 8 ||
                  activeTabIndex === 4
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(4)}
            >
              Callback{" "}
              {InquiryStageCounts?.TotalcallBack
                ? `(${InquiryStageCounts?.TotalcallBack})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 5 ||
                  activeTabIndex === 5
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(5)}
            >
              Quoted{" "}
              {InquiryStageCounts?.TotalConfirmed
                ? `(${InquiryStageCounts?.TotalConfirmed})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 6 ||
                  activeTabIndex === 6
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(6)}
            >
              Rejected{" "}
              {InquiryStageCounts?.TotalRejected
                ? `(${InquiryStageCounts?.TotalRejected})`
                : ""}
            </Button>
          </div>
        ) : (
          <div style={{ display: "flex", gap: 10 }} className="mt-1 mb-3">
            <Button
              themeColor={"primary"}
              fillMode={activeTabIndex === 0 ? "solid" : "outline"}
              onClick={() => handleTabChange(0)}
            >
              New{" "}
              {InquiryStageCounts?.TotalNew
                ? `(${InquiryStageCounts?.TotalNew})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 4 ||
                  activeTabIndex === 3
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(3)}
            >
              In Progress{" "}
              {InquiryStageCounts?.TotalInProgress
                ? `(${InquiryStageCounts?.TotalInProgress})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 8 ||
                  activeTabIndex === 4
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(4)}
            >
              Callback{" "}
              {InquiryStageCounts?.TotalcallBack
                ? `(${InquiryStageCounts?.TotalcallBack})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 5 ||
                  activeTabIndex === 5
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(5)}
            >
              Quoted{" "}
              {InquiryStageCounts?.TotalConfirmed
                ? `(${InquiryStageCounts?.TotalConfirmed})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={
                InquiryFilterDetails?.filterInquiryStageID === 6 ||
                  activeTabIndex === 6
                  ? "solid"
                  : "outline"
              }
              onClick={() => handleTabChange(6)}
            >
              Rejected{" "}
              {InquiryStageCounts?.TotalRejected
                ? `(${InquiryStageCounts?.TotalRejected})`
                : ""}
            </Button>
            <Button
              themeColor={"primary"}
              fillMode={activeTabIndex === 1 ? "solid" : "outline"}
              onClick={() => handleTabChange(1)}
            >
              Overall{" "}
              {InquiryStageCounts?.OverallLeads
                ? `(${InquiryStageCounts?.OverallLeads})`
                : ""}
            </Button>
            {UserTypeID < 3 && (
              <Button
                themeColor={"primary"}
                fillMode={activeTabIndex === 2 ? "solid" : "outline"}
                onClick={() => handleTabChange(2)}
              >
                Un-Assigned{" "}
                {InquiryStageCounts?.TotalUnassigned
                  ? `(${InquiryStageCounts?.TotalUnassigned})`
                  : ""}
              </Button>
            )}
          </div>
        )}
        {/* {InquiryList && InquiryList.length ? ( */}
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 370px)" }}
          className="responsive-table"
          filterable={false}
          dataItemKey={DATA_ITEM_KEY}
          data={InquiryList?.map((item: any) => ({
            ...item,
            [SELECTED_FIELD]: selectedState[idGetter(item)],
          }))}
          total={InquiryList[0]?.ItemCount || InquiryList?.length}
          skip={currentPage * pageLimit}
          take={pageLimit}
          selectedField={SELECTED_FIELD}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 50, 100, 500],
            pageSizeValue: pageLimit,
            type: "input",
          }}
          onSelectionChange={onSelectionChange}
          onHeaderSelectionChange={onHeaderSelectionChange}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          {UserTypeID < 3 && (
            <Column
              filterable={false}
              field={SELECTED_FIELD}
              width={50}
              headerSelectionValue={
                dataState?.findIndex(
                  (item: any) => !selectedState[idGetter(item)],
                ) === -1
              }
            />
          )}
          <Column field="TripID" title="Trip ID" width={200} />
          <Column
            field="Name"
            title="Name"
            width={300}
            cells={{
              data: (props: any) => (
                <td {...props.tdProps}>
                  {isEditAccess ? (
                    <>
                      <div
                        className="hoverableName"
                        onClick={() =>
                          navigate("/inquiry/edit", {
                            state: {
                              InquiryID: props.dataItem?.ID,
                              RequirementType: props.dataItem?.RequirementType,
                            },
                          })
                        }
                      >
                        {props.dataItem?.FirstName} {props.dataItem?.LastName}
                      </div>
                      <p className="m-0"> {props.dataItem?.MobileNo}</p>
                      <p className="m-0"> {props.dataItem?.EmailID}</p>
                    </>
                  ) : (
                    <div className="normalName">
                      <p className="m-0">
                        {props.dataItem?.FirstName} {props.dataItem?.LastName}
                      </p>
                      <p className="m-0"> {props.dataItem?.MobileNo}</p>
                      <p className="m-0"> {props.dataItem?.EmailID}</p>
                    </div>
                  )}
                </td>
              ),
            }}
          />
          <Column
            field="InquiryDate"
            title="Inquiry Date"
            width={120}
            cells={{
              data: (props: any) => {
                const toDay = moment();
                const InquiryDate = moment(
                  String(props.dataItem?.InquiryDate),
                  "DD/MM/YYYY",
                  true,
                );
                let remainingDuration = "";

                if (toDay.isValid() && InquiryDate.isValid()) {
                  const duration = moment?.duration(toDay?.diff(InquiryDate));
                  const durationChunks = {
                    years: duration.years(),
                    months: duration.months(),
                    days: duration.days(),
                  };

                  remainingDuration = `${durationChunks.years > 0
                    ? `${durationChunks.years} Years and `
                    : ""
                    } ${durationChunks.months > 0
                      ? `${durationChunks.months} Months and `
                      : ""
                    } ${durationChunks.days} Days`;
                }

                return (
                  <td {...props.tdProps}>
                    <p className="m-0">{props.dataItem?.InquiryDate}</p>
                    <p className="m-0">{remainingDuration}</p>
                  </td>
                );
              },
            }}
          />
          <Column
            field="TypeofInquiry"
            title="Type of Inquiry"
            width={150}
            cells={{
              data: (props: any) => (
                <td className="text-center fw-bold">
                  {props.dataItem?.TypeofInquiry}
                </td>
              ),
            }}
          />
          <Column field="RequirementType" title="Req. Type" width={120} />
          <Column field="InquiryDestination" title="Destination" width={120} />
          {/* <Column field="TravelDate" title="Date" width={150} /> */}
          <Column
            field="DepartureDate"
            title="Date"
            width={170}
            cells={{
              data: (props: any) => (
                <td>
                  {props?.dataItem?.RequirementType === "PACKAGE" ? (
                    <>
                      <p className="m-0">
                        {" "}
                        Dept. - {props?.dataItem?.TravelDate}
                      </p>
                      <p className="m-0">
                        Rtn. &nbsp;&nbsp; -{" "}
                        {props?.dataItem?.TravelDate &&
                          props?.dataItem?.NoOfNights
                          ? moment(props?.dataItem?.TravelDate, "DD/MM/YYYY")
                            .add(props?.dataItem?.NoOfNights, "days")
                            ?.format("DD/MM/YYYY")
                          : ""}
                      </p>
                    </>
                  ) : props?.dataItem?.RequirementType === "FLIGHT" ? (
                    <>
                      <p className="m-0">
                        Dept. - {props?.dataItem?.DepartureDate}
                      </p>
                      <p className="m-0">
                        Rtn. &nbsp;&nbsp; - {props?.dataItem?.ReturnDate}
                      </p>
                    </>
                  ) : props?.dataItem?.RequirementType === "VISA" ? (
                    <p className="m-0">
                      Travel Date - {props?.dataItem?.DateofTravel}
                    </p>
                  ) : props?.dataItem?.RequirementType === "HOTEL" ? (
                    <>
                      <p className="m-0">
                        CheckIn - {props?.dataItem?.CheckIn}
                      </p>
                      <p className="m-0">
                        CheckOut &nbsp;&nbsp; - {props?.dataItem?.CheckOut}
                      </p>
                    </>
                  ) : null}
                </td>
              ),
            }}
          />
          <Column field="NoOfPax" title="No Of Pax" width={110} />
          <Column
            field="NoOfNights"
            title="No Of Days"
            width={110}
            cells={{
              data: (props: any) => (
                <td {...props.tdProps}>
                  {props?.dataItem?.RequirementType === "VISA" ? (
                    <p className="m-0">{props?.dataItem?.Duration}</p>
                  ) : (
                    <p className="m-0">
                      {props.dataItem?.NoOfNights &&
                        props.dataItem?.NoOfNights > 0
                        ? +props.dataItem?.NoOfNights + 1
                        : ""}
                    </p>
                  )}
                </td>
              ),
            }}
          />
          <Column
            field="InquiryStage"
            title="Inq. Stage"
            width={300}
            cells={{ data: CustomLeadStageCell }}
          />
          <Column
            field="InquiryType"
            title="Inq. Status"
            width={110}
            cells={{ data: CustomLeadStatusCell }}
          />
          <Column field="Remarks" title="Remarks" width={250} />
          <Column field="InquiryOwnerName" title="Owner" width={150} />
          <Column
            field="InquirySource"
            title="Inq. Source"
            width={200}
            cells={{
              data: (props: any) => (
                <td>
                  <p className="mb-0">{props.dataItem?.InquirySource}</p>
                  <p className="mb-0 fw-semibold">{props.dataItem?.AdName}</p>
                </td>
              ),
            }}
          />
          {isQuotationAccess && (
            <Column
              field="ID"
              title="Details"
              cells={{ data: ListingButtonCell }}
              width={"110px"}
              filterable={false}
              locked={true}
            />
          )}
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"200px"}
            filterable={false}
            locked={true}
          />
        </KendoGrid>
      </div>
    </>
  );
};

const DeleteInquiryDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const InquiryID = useAppSelector((state) => state.inquiry.InquiryID);
  const InquiryFilterDetails = useAppSelector(
    (state) => state.inquiry.InquiryFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    const payload = {
      filterContactID: InquiryFilterDetails?.filterContactID,
      filterLeadID: InquiryFilterDetails?.filterLeadID,
      filterNoOfNights: InquiryFilterDetails?.filterNoOfNights,
      filterInquiryStageID: InquiryFilterDetails?.filterInquiryStageID,
      filterInquirySourceID: InquiryFilterDetails?.filterInquirySourceID,
      filterCity: InquiryFilterDetails?.filterCity,
      filterGoingfrom: InquiryFilterDetails?.filterGoingfrom,
      filterDestination: InquiryFilterDetails?.filterDestination,
      filterRequirementType: InquiryFilterDetails?.filterRequirementType,
      filterName: InquiryFilterDetails?.filterName,
      filterMobileNo: InquiryFilterDetails?.filterMobileNo,
      filterEmailID: InquiryFilterDetails?.filterEmailID,
      filterAssignedTo: InquiryFilterDetails?.filterAssignedTo,
      filterUnassignedLeads: InquiryFilterDetails?.filterUnassignedLeads,
      filterFromDate: InquiryFilterDetails?.filterFromDate,
      filterToDate: InquiryFilterDetails?.filterToDate,
      filterFromBudget: InquiryFilterDetails?.Budget?.start,
      filterToBudget: InquiryFilterDetails?.Budget?.end,
      filterIsRecent: InquiryFilterDetails?.filterIsRecent,
      filterAdName: InquiryFilterDetails?.filterAdName,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    if (ID) {
      const response = await dispatch(deleteInquiry(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(getAllInquiries(payload));
        dispatch(closeDialog());
        dispatch(clearInquiryID());
      } else {
        dispatch(getAllInquiries(payload));
        dispatch(closeDialog());
        dispatch(clearInquiryID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteInquiry" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Inquiry?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Inquiry?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(InquiryID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const InquiryFollowUpDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const InquiryID = useAppSelector((state) => state.inquiry.InquiryID);
  const loading = useAppSelector((state) => state.inquiry.loading);
  const InquiryFilterDetails = useAppSelector(
    (state) => state.inquiry.InquiryFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleSubmit = async (values: any) => {
    if (InquiryID) {
      const Payload = {
        LeadID: 0,
        InquiryID: InquiryID ? +InquiryID : null,
        FollowupType: "INQUIRY",
        FollowupDate: values?.FollowupDate
          ? moment(values?.FollowupDate)?.format("YYYY-MM-DD")
          : "",
        FollowupTime: values?.FollowupTime
          ? moment(values?.FollowupTime)?.format("HH:mm:ss")
          : "",
        Remarks: values?.Remarks ? values?.Remarks : "",
        // FollowupStatus: values?.FollowupStatus ? values?.FollowupStatus : "",
        // IsCompleted: values?.IsCompleted ? values?.IsCompleted : false,
      };
      try {
        const response = await dispatch(insertFollowUp(Payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          const inqPayload = {
            filterContactID: InquiryFilterDetails?.filterContactID,
            filterLeadID: InquiryFilterDetails?.filterLeadID,
            filterNoOfNights: InquiryFilterDetails?.filterNoOfNights,
            filterInquiryStageID: InquiryFilterDetails?.filterInquiryStageID,
            filterInquirySourceID: InquiryFilterDetails?.filterInquirySourceID,
            filterCity: InquiryFilterDetails?.filterCity,
            filterGoingfrom: InquiryFilterDetails?.filterGoingfrom,
            filterDestination: InquiryFilterDetails?.filterDestination,
            filterRequirementType: InquiryFilterDetails?.filterRequirementType,
            filterName: InquiryFilterDetails?.filterName,
            filterMobileNo: InquiryFilterDetails?.filterMobileNo,
            filterEmailID: InquiryFilterDetails?.filterEmailID,
            filterAssignedTo: InquiryFilterDetails?.filterAssignedTo,
            filterUnassignedLeads: InquiryFilterDetails?.filterUnassignedLeads,
            filterFromDate: InquiryFilterDetails?.filterFromDate,
            filterToDate: InquiryFilterDetails?.filterToDate,
            filterFromBudget: InquiryFilterDetails?.Budget?.start,
            filterToBudget: InquiryFilterDetails?.Budget?.end,
            filterIsRecent: InquiryFilterDetails?.filterIsRecent,
            filterAdName: InquiryFilterDetails?.filterAdName,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          };
          dispatch(getAllInquiries(inqPayload));
          dispatch(closeDialog());
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {dialogName === "inquiryFollowUp" && (
        <AppDialog>
          <>
            <Form
              initialValues={
                {
                  // FollowupStatus: "NA",
                }
              }
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 500 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Add Follow Up"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name={"FollowupDate"}
                        label="Follow up Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        astrike={true}
                        validator={requiredValidator}
                        minDate={moment().toDate()}
                      />
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        wrapperClassName="w-100"
                        id={"FollowupTime"}
                        name={"FollowupTime"}
                        label={"Follow up Time"}
                        component={FormTimePicker}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="mb-2">
                      <Field
                        id={"Remarks"}
                        name={"Remarks"}
                        label={"Remarks"}
                        placeholder={"Remarks"}
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                    {/* <GridLayoutItem>
                      <Field
                        id={"FollowupStatus"}
                        name={"FollowupStatus"}
                        component={FormRadioGroup}
                        layout="horizontal"
                        options={FOLLOWUPSTATUS}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem> */}
                    {/* <GridLayoutItem>
                      <Field
                        wrapperClassName="fw-600"
                        name={"IsCompleted"}
                        label={"Is Completed"}
                        Size="medium"
                        component={FormCheckbox}
                      />
                    </GridLayoutItem> */}
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonForAll
                        style={{ marginLeft: 6 }}
                        label={"Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const InquiryFollowUpListDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.inquiry.loading);
  const InquiryFollowupList = useAppSelector(
    (state) => state.inquiry.InquiryFollowupList,
  );

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        duration: 0.5,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const handleOpenCompleteFollowupDialog = (ID: number) => {
    dispatch(openCompleteFollowupDialog());
    dispatch(setFolloupID(ID));
  };

  return (
    <>
      {dialogName === "inquiryFollowUpList" && (
        <AppDialog>
          <div style={{ minWidth: 600, maxWidth: 800 }}>
            <GridLayoutItem className="position-relative">
              <Typography.h4 className="typography-head">
                {"Follow Up List"}
              </Typography.h4>
              <IconButton
                className="typography-dialog-close-icon"
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4, top: 7 }}
                onClick={() => dispatch(closeDialog())}
                icon={RxCross1}
              />
            </GridLayoutItem>
            {loading && <LoadingPanel gridRef={gridRef} />}
            {!loading && (
              <motion.ul
                className="followups-list"
                variants={listVariants}
                initial="hidden"
                animate="visible"
                // key={activeTab}
                style={{
                  maxHeight: 300,
                  overflowX: "auto",
                  scrollbarWidth: "thin",
                }}
              >
                {InquiryFollowupList?.length > 0 ? (
                  InquiryFollowupList.map((followUp) => (
                    <motion.li
                      key={followUp.ID}
                      className="followup-item"
                      variants={itemVariants}
                      style={{
                        padding: "4px",
                        background: followUp?.IsCompleted
                          ? "#33ff3340"
                          : "transparent",
                      }}
                    // onClick={() => handleEditLeadOrInquiry(followUp)}
                    >
                      <div className="text-end">
                        Added by: {followUp.FollowUpAddedbyName}
                      </div>
                      <div className="followup-header">
                        <span className="lead-name">{followUp.Name}</span>
                        <span className="followup-date-time">
                          {followUp.FollowupDate} | {followUp.FollowupTime}
                        </span>
                      </div>
                      <div className="followup-header gap-2">
                        <p className="followup-description">
                          {followUp.Remarks}
                        </p>
                        {
                          !followUp.IsCompleted && (
                            <span className="followup-date-time">
                              <motion.button
                                className={`tab-btn active`}
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  handleOpenCompleteFollowupDialog(
                                    followUp?.ID || 0,
                                  );
                                }}
                                whileHover={{
                                  scale: 1.05,
                                  transition: { duration: 0.2 },
                                }}
                                whileTap={{ scale: 0.95 }}
                                style={{ padding: "5px 10px" }}
                              >
                                Complete
                              </motion.button>
                            </span>
                          )
                          //  : (
                          //   <span
                          //     style={{
                          //       padding: "5px 10px",
                          //       borderRadius: "5px",
                          //       background: "#109510",
                          //       fontWeight: "bold",
                          //       color: "white",
                          //     }}
                          //   >
                          //     Completed
                          //   </span>
                          // )
                        }
                      </div>
                      {followUp?.IsCompleted && (
                        <div
                          className="followup-header gap-3 mt-1"
                          style={{ background: "palegreen" }}
                        >
                          <p className="followup-description">
                            <b>Completion Remarks :</b>{" "}
                            {followUp?.CompletedRemarks}
                          </p>
                          <span className="" style={{ whiteSpace: "nowrap" }}>
                            {followUp.CompletedDate}{" "}
                            {followUp.CompletedDate &&
                              followUp.CompletedTime &&
                              "|"}{" "}
                            {followUp.CompletedTime}
                          </span>
                        </div>
                      )}
                    </motion.li>
                  ))
                ) : (
                  <motion.p key="no-followups" className="no-followups">
                    No follow-ups found for this Inquiry.
                  </motion.p>
                )}
              </motion.ul>
            )}
            <GridLayoutItem
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: 20,
              }}
            >
              <DialogCloseButton themeColor="primary" />
            </GridLayoutItem>
          </div>
        </AppDialog>
      )}
    </>
  );
};

const InquiryStageDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const InquiryID = useAppSelector((state) => state.inquiry.InquiryID);
  const InquiryStageDetails = useAppSelector(
    (state) => state.inquiry.InquiryStageDetails,
  );
  // const InquiryStageID = useAppSelector(
  //   (state) => state.inquiry.InquiryStageID,
  // );
  const loading = useAppSelector((state) => state.inquiry.loading);
  const LeadStageList = useAppSelector(
    (state) => state.leadStage.LeadStageList,
  );
  const InquiryFilterDetails = useAppSelector(
    (state) => state.inquiry.InquiryFilterDetails,
  );
  const LostReasonList = useAppSelector(
    (state) => state.lostReason.LostReasonList,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    dispatch(getAllActiveLeadStage("INQUIRY"));
    dispatch(getAllActiveLostReasons());
  }, []);

  const handleSubmit = async (values: any) => {
    if (InquiryID) {
      const Payload = {
        ID: InquiryID ? +InquiryID : null,
        InquiryStageID: values?.InquiryStageID ? +values?.InquiryStageID : null,
        LostReasonID: values?.LostReasonID ? +values?.LostReasonID : null,
      };
      try {
        const response = await dispatch(updateInquiryStageStatus(Payload));
        const inquiryPayload = {
          filterContactID: InquiryFilterDetails?.filterContactID,
          filterLeadID: InquiryFilterDetails?.filterLeadID,
          filterNoOfNights: InquiryFilterDetails?.filterNoOfNights,
          filterInquiryStageID: InquiryFilterDetails?.filterInquiryStageID,
          filterInquirySourceID: InquiryFilterDetails?.filterInquirySourceID,
          filterCity: InquiryFilterDetails?.filterCity,
          filterGoingfrom: InquiryFilterDetails?.filterGoingfrom,
          filterDestination: InquiryFilterDetails?.filterDestination,
          filterRequirementType: InquiryFilterDetails?.filterRequirementType,
          filterName: InquiryFilterDetails?.filterName,
          filterMobileNo: InquiryFilterDetails?.filterMobileNo,
          filterEmailID: InquiryFilterDetails?.filterEmailID,
          filterAssignedTo: InquiryFilterDetails?.filterAssignedTo,
          filterUnassignedLeads: InquiryFilterDetails?.filterUnassignedLeads,
          filterFromDate: InquiryFilterDetails?.filterFromDate,
          filterToDate: InquiryFilterDetails?.filterToDate,
          filterFromBudget: InquiryFilterDetails?.Budget?.start,
          filterToBudget: InquiryFilterDetails?.Budget?.end,
          filterIsRecent: InquiryFilterDetails?.filterIsRecent,
          filterAdName: InquiryFilterDetails?.filterAdName,
          limit: +pageLimit,
          skip: +currentPage * +pageLimit,
        };

        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getAllInquiries(inquiryPayload));
          dispatch(closeDialog());
          dispatch(clearInquiryID());
          // dispatch(clearInquiryStageID());
          dispatch(clearInquiryStageDetails());
        } else {
          dispatch(getAllInquiries(inquiryPayload));
          dispatch(closeDialog());
          dispatch(clearInquiryID());
          // dispatch(clearInquiryStageID());
          dispatch(clearInquiryStageDetails());
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {dialogName === "inquiryStageChange" && (
        <AppDialog>
          <>
            <Form
              initialValues={InquiryStageDetails}
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 300 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h5 className="typography-head">
                        {"Update Inquiry Status"}
                      </Typography.h5>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ top: 1 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"InquiryStageID"}
                        name={"InquiryStageID"}
                        label={"Inquiry Stage"}
                        placeholder="Inquiry Stage"
                        component={FormSelectionField}
                        options={LeadStageList?.map((leadstage: ILeadStage) => {
                          return {
                            value: leadstage?.ID,
                            label: leadstage?.LeadStage,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    {formRenderProps.valueGetter("InquiryStageID") === 6 && (
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100"
                          id={"LostReasonID"}
                          name={"LostReasonID"}
                          label={"Lost Reason"}
                          placeholder="Lost Reason"
                          astrike={
                            formRenderProps.valueGetter("InquiryStageID") === 6
                              ? true
                              : false
                          }
                          validator={
                            formRenderProps.valueGetter("InquiryStageID") === 6
                              ? requiredValidator
                              : skipValidator
                          }
                          component={FormSelectionField}
                          options={LostReasonList?.map(
                            (lostreason: ILostReason) => {
                              return {
                                value: lostreason?.ID,
                                label: lostreason?.LostReason,
                              };
                            },
                          )}
                        />
                      </GridLayoutItem>
                    )}
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: 20,
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonForAll
                        style={{ marginLeft: 6 }}
                        label={"Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const InquiryStatusDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const InquiryID = useAppSelector((state) => state.inquiry.InquiryID);
  const InquiryType = useAppSelector((state) => state.inquiry.InquiryType);
  const loading = useAppSelector((state) => state.inquiry.loading);

  const InquiryFilterDetails = useAppSelector(
    (state) => state.inquiry.InquiryFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleSubmit = async (values: any) => {
    if (InquiryID) {
      const Payload = {
        ID: InquiryID ? +InquiryID : null,
        InquiryType: values?.InquiryType ? values?.InquiryType : "",
      };
      try {
        const response = await dispatch(updateInquiryStatus(Payload));
        const inquiryPayload = {
          filterContactID: InquiryFilterDetails?.filterContactID,
          filterLeadID: InquiryFilterDetails?.filterLeadID,
          filterNoOfNights: InquiryFilterDetails?.filterNoOfNights,
          filterInquiryStageID: InquiryFilterDetails?.filterInquiryStageID,
          filterInquirySourceID: InquiryFilterDetails?.filterInquirySourceID,
          filterCity: InquiryFilterDetails?.filterCity,
          filterGoingfrom: InquiryFilterDetails?.filterGoingfrom,
          filterDestination: InquiryFilterDetails?.filterDestination,
          filterRequirementType: InquiryFilterDetails?.filterRequirementType,
          filterName: InquiryFilterDetails?.filterName,
          filterMobileNo: InquiryFilterDetails?.filterMobileNo,
          filterEmailID: InquiryFilterDetails?.filterEmailID,
          filterAssignedTo: InquiryFilterDetails?.filterAssignedTo,
          filterUnassignedLeads: InquiryFilterDetails?.filterUnassignedLeads,
          filterFromDate: InquiryFilterDetails?.filterFromDate,
          filterToDate: InquiryFilterDetails?.filterToDate,
          filterFromBudget: InquiryFilterDetails?.Budget?.start,
          filterToBudget: InquiryFilterDetails?.Budget?.end,
          filterIsRecent: InquiryFilterDetails?.filterIsRecent,
          filterAdName: InquiryFilterDetails?.filterAdName,
          limit: +pageLimit,
          skip: +currentPage * +pageLimit,
        };

        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getAllInquiries(inquiryPayload));
          dispatch(closeDialog());
          dispatch(clearInquiryID());
          dispatch(clearInquiryStatus());
        } else {
          dispatch(getAllInquiries(inquiryPayload));
          dispatch(closeDialog());
          dispatch(clearInquiryID());
          dispatch(clearInquiryStatus());
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {dialogName === "inquiryStatusChange" && (
        <AppDialog>
          <>
            <Form
              initialValues={{
                InquiryType: InquiryType,
              }}
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 300 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h5 className="typography-head">
                        {"Update Inquiry Status"}
                      </Typography.h5>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ top: 1 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"InquiryType"}
                        name={"InquiryType"}
                        label={"Inquiry Status"}
                        placeholder="Inquiry Status"
                        component={FormSelectionField}
                        options={FOLLOWUPSTATUS?.map((status: any) => {
                          return {
                            value: status.value,
                            label: status.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: 20,
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonForAll
                        style={{ marginLeft: 6 }}
                        label={"Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const FollowupCompleteDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const completeFollowupOpen = useAppSelector(
    (state) => state.inquiry.completeFollowupOpen,
  );

  const followUpLoading = useAppSelector(
    (state) => state.dashboard.followUpLoading,
  );
  const followupId = useAppSelector((state) => state.dashboard.followupId);
  const InquiryID = useAppSelector((state) => state.inquiry.InquiryID);

  const handleSubmit = async (values: any) => {
    const payload = {
      ID: followupId ? +followupId : null,
      CompletedRemarks: values?.CompletedRemarks
        ? values?.CompletedRemarks
        : "",

      IsCompleted: true,
    };
    if (followupId) {
      const res = await dispatch(updateFollowUpStatus(payload));
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          getFollowupsByInquiryID({
            ID: InquiryID,
            FollowupType: "INQUIRY",
          }),
        );
        dispatch(closeCompleteFollowupDialog());
      }
    }
  };

  return (
    <>
      <CustomAppDialog open={completeFollowupOpen}>
        <>
          {followUpLoading && <LoadingPanel gridRef={gridRef} />}
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ minWidth: 500 }}>
                <GridLayout>
                  <GridLayoutItem className="position-relative">
                    <Typography.h4 className="typography-head">
                      {"Complete Followup"}
                    </Typography.h4>
                    <IconButton
                      className="typography-dialog-close-icon"
                      type="button"
                      fillMode={"flat"}
                      themeColor={"dark"}
                      style={{ marginRight: 4, top: 7 }}
                      onClick={() => dispatch(closeCompleteFollowupDialog())}
                      icon={RxCross1}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"CompletedRemarks"}
                      name={"CompletedRemarks"}
                      label={"Completed Remarks"}
                      placeholder={"Completed Remarks"}
                      component={FormTextArea}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: 20,
                    }}
                  >
                    <CustomDialogCloseButton
                      themeColor="primary"
                      closeDialogFunction={closeCompleteFollowupDialog}
                    />
                    <ButtonWithLoading
                      label={"Complete"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || followUpLoading}
                      loading={followUpLoading}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </>
      </CustomAppDialog>
    </>
  );
};

const InquiryHistoryDialog: React.FC = () => {
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const InquiryAssignUserHistory = useAppSelector(
    (state) => state.inquiry.InquiryAssignUserHistory,
  );

  return (
    <>
      {dialogName === "inquiryHistory" && (
        <AppDialog>
          <>
            <Typography.h5>{"Inquiry History"}</Typography.h5>
            <GridLayout style={{ minWidth: 700 }}>
              <GridLayoutItem
                style={{
                  maxHeight: "450px",
                  overflowY: "auto",
                }}
              >
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ background: "black", color: "white" }}>
                        Assigned Time
                      </th>
                      <th style={{ background: "black", color: "white" }}>
                        Assigned To
                      </th>
                      <th style={{ background: "black", color: "white" }}>
                        Assigned By
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {InquiryAssignUserHistory.map((record: any) => (
                      <tr>
                        <td>{record?.AssignedTime}</td>
                        <td>{record?.AssignedTo}</td>
                        <td>{record?.AssignedBy}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: 10,
                }}
              >
                <DialogCloseButton themeColor="error" fillMode={"solid"} />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Inquiry;
